import { motion } from "framer-motion";

const COW_INFOGRAPHIC_URL = "https://customer-assets.emergentagent.com/job_pure-milk-navi/artifacts/99nmvblk_Rebuild_to_avoid_202604221752.jpeg";

export default function CowInfographic() {
  return (
    <section className="dd-section bg-dd-page relative overflow-hidden" data-testid="cow-infographic-section">
      {/* Subtle gold corner glow */}
      <div className="absolute top-0 left-0 w-64 h-64 opacity-20 pointer-events-none"
           style={{ background: "radial-gradient(circle at top left, #C9A24C 0%, transparent 60%)" }} />
      <div className="absolute bottom-0 right-0 w-64 h-64 opacity-20 pointer-events-none"
           style={{ background: "radial-gradient(circle at bottom right, #C9A24C 0%, transparent 60%)" }} />

      <div className="dd-container relative">
        <div className="text-center mb-10 max-w-2xl mx-auto">
          <div className="dd-label text-dd-gold">The Divya Dhara Difference</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dd-cream mt-3">
            Why every drop matters
          </h2>
          <div className="dd-ornament my-5"><span className="text-lg">✦</span></div>
          <p className="text-dd-cream-muted font-devanagari text-lg">
            हर बूंद में अमृत
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto max-w-5xl"
        >
          <div className="relative rounded-2xl overflow-hidden border-2 border-dd-gold/40 shadow-[0_40px_80px_-20px_rgba(201,162,76,0.4)]">
            {/* Gold corner ornaments */}
            <div className="absolute top-3 left-3 w-10 h-10 border-t-2 border-l-2 border-dd-gold z-10 pointer-events-none rounded-tl-lg" />
            <div className="absolute top-3 right-3 w-10 h-10 border-t-2 border-r-2 border-dd-gold z-10 pointer-events-none rounded-tr-lg" />
            <div className="absolute bottom-3 left-3 w-10 h-10 border-b-2 border-l-2 border-dd-gold z-10 pointer-events-none rounded-bl-lg" />
            <div className="absolute bottom-3 right-3 w-10 h-10 border-b-2 border-r-2 border-dd-gold z-10 pointer-events-none rounded-br-lg" />

            <img
              src={COW_INFOGRAPHIC_URL}
              alt="Divya Dhara — Har Boond Main Amrit — GIR cow farming infographic"
              className="w-full h-auto block"
              loading="lazy"
            />
          </div>
        </motion.div>

        <p className="text-center text-sm text-dd-cream-muted mt-8 italic max-w-xl mx-auto">
          From grass-fed grazing to sealed food-grade packets — every step is curated for your family.
        </p>
      </div>
    </section>
  );
}
